<template>
  <PageBreadcrumbs :items="breadcrumbs" />
  <ContentCard>
    <template #header>
      <ContentCardSubheader>
        {{ t('Reviews.product.view.preferencesTitle', { productName: product.title }) }}
        <template #actions>
          <RouterLink
            class="btn-primary-color-s"
            data-testid="reviews-preferences-edit-button"
            :to="{ name: ReviewsRouteName.ReviewsProductPreferencesEdit, params: { productId: product.id } }"
            @click="track('profile_update_start', { surface: 'editor', entity_type: 'tool', entity_id: product.id })"
          >
            {{ t('Reviews.product.action.edit') }}
          </RouterLink>
        </template>
      </ContentCardSubheader>
    </template>
    <div class="flex flex-col gap-y-10 py-6">
      <PreferenceItem
        :items="product.vendorEmailAddresses || []"
        :description="t('Reviews.product.view.preferences.vendorEmails.description')"
        :title="t('Reviews.product.view.preferences.vendorEmails.title')"
        data-testid="reviews-preference-vendor-emails"
      />
      <PreferenceItem
        :items="product.contactFormRecipients || []"
        :description="t('Reviews.product.view.preferences.contactEmails.description')"
        :title="t('Reviews.product.view.preferences.contactEmails.title')"
        data-testid="reviews-preference-contact-emails"
      />
      <PreferenceItem
        :items="product.pageVisitReportEmails || []"
        :description="t('Reviews.product.view.preferences.pageVisitReportEmails.description')"
        :title="t('Reviews.product.view.preferences.pageVisitReportEmails.title')"
        data-testid="reviews-pref-emails"
      />
    </div>
  </ContentCard>
  <IntegrationsCard v-if="product.configFlags.pageVisitReportsEnabled" class="mt-6" entity-type="tool" />
</template>

<script setup lang="ts">
import { track } from '@ramp106/omrjs-tracking-reviews'
import { useI18n } from 'vue-i18n'

import PageBreadcrumbs from '@/components/PageBreadcrumbs.vue'
import IntegrationsCard from '@/components/ReviewsCommon/Integrations/IntegrationsCard.vue'
import PreferenceItem from '@/components/ReviewsManagement/Preferences/PreferenceItem.vue'
import { useReviewsProductBreadcrumbs } from '@/composables/breadcrumbs/useReviewsProductBreadcrumbs'
import type { ProductData } from '@/gql/reviews'
import { ReviewsRouteName } from '@/router/types'
import ContentCard from '@/ui/ContentCard.vue'
import ContentCardSubheader from '@/ui/ContentCardSubheader.vue'

const props = defineProps<{
  product: ProductData
}>()

const { t } = useI18n()
const breadcrumbs = useReviewsProductBreadcrumbs(props.product)
</script>
